import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import LoadingSpinner from './components/LoadingSpinner';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ImmobilisationsPage from './pages/ImmobilisationsPage';
import ImmobilisationFormPage from './pages/ImmobilisationFormPage';
import ImmobilisationDetailPage from './pages/ImmobilisationDetailPage';
import CartePage from './pages/CartePage';
import ScanPage from './pages/ScanPage';
import CategoriesPage from './pages/CategoriesPage';
import ServicesPage from './pages/ServicesPage';
import UsersPage from './pages/UsersPage';
import HistoriquePage from './pages/HistoriquePage';
import EnrollPage from './pages/EnrollPage';
import QRGeneratorPage from './pages/QRGeneratorPage';
import ProfilPage from './pages/ProfilPage';

function App() {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/enroll/:id" element={<EnrollPage />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/immobilisations"
        element={
          <ProtectedRoute>
            <ImmobilisationsPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/immobilisations/new"
        element={
          <ProtectedRoute>
            <ImmobilisationFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/immobilisations/:id"
        element={
          <ProtectedRoute>
            <ImmobilisationDetailPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/immobilisations/:id/edit"
        element={
          <ProtectedRoute>
            <ImmobilisationFormPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/carte"
        element={
          <ProtectedRoute>
            <CartePage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/scan"
        element={
          <ProtectedRoute>
            <ScanPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/categories"
        element={
          <ProtectedRoute>
            <CategoriesPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/services"
        element={
          <ProtectedRoute>
            <ServicesPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/users"
        element={
          <ProtectedRoute requiredRole="admin">
            <UsersPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/historique"
        element={
          <ProtectedRoute>
            <HistoriquePage />
          </ProtectedRoute>
        }
      />

      <Route path="/profil" element={<ProtectedRoute><ProfilPage /></ProtectedRoute>} />
      <Route path="/qr-generator" element={<ProtectedRoute requiredRole="admin"><QRGeneratorPage /></ProtectedRoute>} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
